import { render, staticRenderFns } from "./formOne.vue?vue&type=template&id=235c1ac1&scoped=true&"
import script from "./formOne.vue?vue&type=script&lang=js&"
export * from "./formOne.vue?vue&type=script&lang=js&"
import style0 from "./formOne.vue?vue&type=style&index=0&id=235c1ac1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c1ac1",
  null
  
)

export default component.exports